document.addEventListener('DOMContentLoaded', function () {

  // Mobile menu toggle
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  // FAQ accordion
  document.querySelectorAll('[data-faq-item]').forEach(function (item) {
    var btn = item.querySelector('[data-faq-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var wasOpen = item.classList.contains('is-open');
      item.closest('[data-faq-list]').querySelectorAll('[data-faq-item]').forEach(function (i) {
        i.classList.remove('is-open');
      });
      if (!wasOpen) item.classList.add('is-open');
    });
  });

  // Cart drawer
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartClose = document.querySelector('[data-cart-close]');
  cartOpeners.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (cartDrawer) cartDrawer.hidden = false;
    });
  });
  if (cartClose) {
    cartClose.addEventListener('click', function () {
      cartDrawer.hidden = true;
    });
  }
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      if (e.target === cartDrawer) cartDrawer.hidden = true;
    });
  }

  // Add to cart via AJAX (product form + collection/home quick add)
  document.querySelectorAll('[data-atc-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var countEls = document.querySelectorAll('[data-cart-count]');
          countEls.forEach(function (el) { el.textContent = cart.item_count; });
          if (cartDrawer) cartDrawer.hidden = false;
        })
        .catch(function () {
          form.submit();
        });
    });
  });

  // Variant selection on product pages
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var raw = form.getAttribute('data-product-json');
    var variants = [];
    try { variants = JSON.parse(raw.replace(/&quot;/g, '"').replace(/&#39;/g, "'")); } catch (e) {}
    var selects = form.querySelectorAll('[data-option-selector]');
    var hiddenId = form.querySelector('[data-variant-id]');
    var submitBtn = form.querySelector('[data-atc-form-submit]');

    function currentSelection() {
      var vals = [];
      selects.forEach(function (s) { vals.push(s.value); });
      return vals;
    }
    function findVariant() {
      var vals = currentSelection();
      if (!vals.length) return variants[0];
      return variants.find(function (v) {
        return [v.option1, v.option2, v.option3].filter(Boolean).every(function (opt, i) {
          return vals[i] === undefined || opt === vals[i];
        }) && vals.every(function (val, i) {
          var opt = [v.option1, v.option2, v.option3][i];
          return opt === undefined || opt === val;
        });
      });
    }
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var match = findVariant();
        if (match && hiddenId) {
          hiddenId.value = match.id;
          if (submitBtn) {
            submitBtn.disabled = !match.available;
            submitBtn.textContent = match.available
              ? 'Ajouter au panier'
              : 'Épuisé';
          }
        }
      });
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty-input]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
      });
    });
  });

});
